import React, { Component } from "react";
import "../../styles/ConnectionsPage/ConnectionFilter.scss";
import { withRouter } from "react-router-dom";
import ButtonComponent from "../../../shared/button/components/ButtonComponent";

class ConnectionFilter extends Component {
  handleClickPending() {
    const pending = 1;
    this.props.onChange(pending);
  }

  handleClickAll() {
    const pending = 0;
    this.props.onChange(pending);
  }

  render() {
    const { pending } = this.props;
    return (
      <div className="connection-filter">
        <ButtonComponent
          action={() => this.handleClickPending()}
          className={pending === 1 ? "button--active" : ""}
        >
          PENDING
        </ButtonComponent>
        <ButtonComponent
          action={() => this.handleClickAll()}
          className={pending === 0 ? "button--active" : ""}
        >
          ALL
        </ButtonComponent>
      </div>
    );
  }
}

export default withRouter(ConnectionFilter);
